import { getCDN } from './utils/getEnvironment'

const NEW_BADGE_DAYS = 30

// Badge stays visible for NEW_BADGE_DAYS after the release date stamped
// in .env by the deploy scripts (REACT_APP_<APP>_RELEASED).
const isNew = (releaseDate) => {
  if (!releaseDate) return false
  const elapsed = Date.now() - new Date(releaseDate).getTime()
  return elapsed < NEW_BADGE_DAYS * 24 * 60 * 60 * 1000
}

export const apps = [
  {
    imageUrl: `${getCDN()}shuttlepassenger/icon.png`,
    appDescription: 'Shuttle service app for Trenders',
    imageAlt: 'shuttle-app',
    title: 'Shuttle App',
    version: process.env.REACT_APP_SHUTTLEPASSENGER,
    isNew: isNew(process.env.REACT_APP_SHUTTLEPASSENGER_RELEASED),
    app: {
      foldername: 'shuttlepassenger',
      android: 'shuttlepassenger_v' + process.env.REACT_APP_SHUTTLEPASSENGER,
    },
  },
]
